<template>
  <div>
    <div
      v-if="hasLeadingGuards"
      :tabIndex="disabled || disableLockFromEvent ? -1 : 0"
      :style="hidden"
    ></div>
    <div
      v-if="hasLeadingGuards"
      :tabIndex="disabled || disableLockFromEvent ? -1 : 1"
      :style="hidden"
    ></div>

    <div  v-bind="groupAttr" :data-lock="_uid">
      <slot></slot>
    </div>

    <div
      v-if="hasTailingGuards"
      :tabIndex="disabled || disableLockFromEvent ? -1 : 0"
      :style="hidden"
    ></div>
  </div>
</template>

<script>
import moveFocusInside, {
  focusInside,
  focusIsHidden,
} from "../../node_modules/focus-lock";
import { constants } from "../../node_modules/focus-lock";

let instances = [];
let lastActiveTrap = 0;
let lastActiveFocus = null;
let focusWasOutsideWindow = false;
let disableAllLocks = false;

function deferAction(action) {
  const setImmediate = window.setImmediate;
  if (typeof setImmediate !== "undefined") {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}

const focusOnBody = () => document && document.activeElement === document.body;

const isFreeFocus = () => focusOnBody() || focusIsHidden();

const activateTrap = () => {
  let result = false;

  if (lastActiveTrap && !lastActiveTrap.disabled) {
    const { observed, onActivation } = lastActiveTrap;
    if (focusWasOutsideWindow || !isFreeFocus() || !lastActiveFocus) {
      if (observed && !focusInside(observed)) 
      {
        lastActiveFocus = lastActiveFocus || (document && document.activeElement);
        onActivation();
        result = moveFocusInside(observed, lastActiveFocus);
      }
      focusWasOutsideWindow = false;
    }
  }
  return result;
};

const reducePropsToState = (propsList) => {
  var result = propsList.filter(({ disabled }) => !disabled).slice(-1)[0];
  return result;
};

const handleStateChangeOnClient = (trap) => {
  if(!disableAllLocks)
  {
    internalLoggin("handleState_trap", trap);
    internalLoggin("handleState_lastActiveTrap",lastActiveTrap)
    if (lastActiveTrap !== trap && trap !== undefined) {
        lastActiveTrap = trap;
    }
    if (trap) {
        deferAction(activateTrap);
    }
    else if(trap === undefined && lastActiveTrap) {
        returnFocus(lastActiveTrap);
    }
  }
  
};

const returnFocus = (lastActiveTrap) => {
  if (
    lastActiveTrap.vue.returnfocus &&
    lastActiveTrap.vue.originalFocusedElement &&
    lastActiveTrap.vue.originalFocusedElement.focus
  ) {
    internalLoggin("returning focus","-")
    // We return focus to the original element
    lastActiveTrap.vue.originalFocusedElement.focus();
    
    // We return focus to parent lock, if lock is inside parent
    // Use this check if we are insde nested locks
    var parentFocus = instances.find(element => element.vue._uid == lastActiveTrap.observedParentLockId);
    if(parentFocus)
    {
        handleStateChangeOnClient(parentFocus);
    }
  }
};

const emitChange = () => {
  handleStateChangeOnClient(reducePropsToState(instances));
};


const onKeyEvent = (event) => {
  if(disableAllLocks)
  {
    internalLoggin("keydown: ","-");
    disableAllLocks = false;
    instances.forEach(x => x.vue.disableLockFromEvent = false);
    emitChange();
  }
};

const onClickEvent = (event) => 
{
    if(!disableAllLocks)
    {
        internalLoggin("mousedown: onClickOutsideLock",lastActiveTrap);
        disableAllLocks = true;
        instances.forEach(x => x.vue.disableLockFromEvent = true);
        emitChange();
    }
}

const onFocusInEvent = (event) => {
  if(!disableAllLocks)
  {
    internalLoggin("focusin: onTrap: start", event)
    if (activateTrap() && event) {
        // prevent scroll jump
        internalLoggin("focusin: onTrap: end", "-")
        event.stopPropagation();
        event.preventDefault();
    }
  }
};

const onFocusoutEvent = (event) => {
  if(!disableAllLocks)
  {
    internalLoggin("focusout: onBlur","-");
    deferAction(activateTrap);
  }
};

const onWindowBlur = () => {
  internalLoggin("blur: onWindowblur","-");
  focusWasOutsideWindow = true;
};



const attachHandler = () => {
  document.addEventListener("keydown", onKeyEvent);
  document.addEventListener("mousedown", onClickEvent);
  document.addEventListener("focusin", onFocusInEvent, true);
  document.addEventListener("focusout", onFocusoutEvent);
  window.addEventListener("blur", onWindowBlur);
};

const detachHandler = () => {
  document.removeEventListener("keydown", onKeyEvent);
  document.removeEventListener("mousedown", onClickEvent);
  document.removeEventListener("focusin", onFocusInEvent, true);
  document.removeEventListener("focusout", onFocusoutEvent);
  window.removeEventListener("blur", onWindowBlur);
};


const internalLoggin = (pretext, object) => {
    var enableLoggin = false;
    if(enableLoggin)
    {
        var stamp = Date.now().toString();
        var stamText = stamp.slice(stamp.length - 5) + ": ";
        console.info(stamText, pretext, object);
    }
};

export default {
  name: "FocusLock",
  props: {
    returnfocus: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    noFocusGuards: {
      type: [Boolean, String],
      default: false,
    },
    group: {
      type: String,
    },
    updateValue:{
        type: Boolean,
    }
  },
  data() {
    return {
      observed: null,
      disableLockFromEvent: false,
      data: {},
      hidden: "", //    "width: 1px;height: 0px;padding: 0;overflow: hidden;position: fixed;top: 0;left: 0;"
    };
  },
  watch: {
    disabled() {
      this.data.disabled = this.disabled;
      if(!disableAllLocks){
            emitChange();
        };
    },
    
  },
  computed: {
    groupAttr() {
      return { [constants.FOCUS_GROUP]: this.group };
    },
    hasLeadingGuards() {
      return this.noFocusGuards !== true;
    },
    hasTailingGuards() {
      return this.hasLeadingGuards && this.noFocusGuards !== "tail";
    }
  },
  mounted() {
    this.data.vue = this;
    this.data.observed = this.$el.querySelector("[data-lock]");

    // Selecting parent lock id if any
    var parentLockElement = this.$el.closest("[data-lock]");
    this.data.observedParentLockId = parentLockElement !== null ? parentLockElement.getAttribute("data-lock") : null;

    this.data.disabled = this.disabled;
    this.disableLockFromEvent = disableAllLocks;
    this.data.onActivation = () => {
      this.originalFocusedElement =
        this.originalFocusedElement || (document && document.activeElement);
    };

    if (!instances.length) {
      attachHandler();
    }
    instances.push(this.data);
    emitChange();
  },
  destroyed() {
    instances = instances.filter(({ vue }) => vue !== this);
    if (!instances.length) {
      detachHandler();
    }
    if (
      this.returnfocus &&
      this.originalFocusedElement &&
      this.originalFocusedElement.focus
    ) {
      this.originalFocusedElement.focus();
    }
    emitChange();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Lock.vue